import { type FC } from 'react'
import { cn } from '../../lib/utils'

export interface BadgeProps {
  title: string
  variant?: 'default' | 'success' | 'warning' | 'error' | 'primary' | 'secondary'
  className?: string
}

const variantClasses: Record<NonNullable<BadgeProps['variant']>, string> = {
  default: 'bg-neutral-100 text-neutral-700 border-neutral-200',
  success: 'bg-success-50 text-success-700 border-success-100',
  warning: 'bg-warning-50 text-warning-700 border-warning-100',
  error: 'bg-error-50 text-error-700 border-error-100',
  primary: 'bg-primary-50 text-primary-700 border-primary-100',
  secondary: 'bg-neutral-50 text-neutral-600 border-neutral-200',
}

export const Badge: FC<BadgeProps> = ({ title, variant = 'default', className }) => {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 text-xs font-medium rounded-md border',
        variantClasses[variant],
        className
      )}
    >
      {title}
    </span>
  )
}
